import * as React from 'react';
import { createImageSrc, createImageWidths } from '../partials/image/image.utils';
import { LARGE_SCREEN_SIZE, MEDIUM_SCREEN_SIZE, SMALL_SCREEN_SIZE } from '../../mediaQueries.const';

export const ampImageWidths = createImageWidths(450, 600, 600);

export const ampAspectRatio = { x: 16, y: 9 };

export const preloadImage = (host: string, path: string, aspectRatio = ampAspectRatio) => {
  return [
    <link key="1" rel="preload" href={createImageSrc(host, path, ampImageWidths.small, aspectRatio, 1)} media={`(max-width: ${SMALL_SCREEN_SIZE}px)`} as="image" />,
    <link key="2" rel="preload" href={createImageSrc(host, path, ampImageWidths.medium, aspectRatio, 1)} media={`(max-width: ${MEDIUM_SCREEN_SIZE}px)`} as="image" />,
    <link key="3" rel="preload" href={createImageSrc(host, path, ampImageWidths.large, aspectRatio, 1)} media={`(min-width: ${LARGE_SCREEN_SIZE}px)`} as="image" />,
  ];
};

export const normalizeDimensions = (aspectRatio = { x: 16, y: 9 }) => {
  return [aspectRatio.x / aspectRatio.y, 1];
};
